import { SignInForm } from "@features/sign-in";

export const LoginPage = () => <SignInForm />;
